module.exports = __webpack_public_path__ + "img/icon_tb_del.9f5fe9b4.svg";